<template>
	<div class="launch" style="font-size: 14px">
		<el-row>
			<el-col :span="24">
				<el-card style="padding-left: 50px" shadow="never">
					<el-row>
						<el-col :span="5" :offset="1">
							<el-radio v-model="radio" label="1"
								><b style="margin-left: 10px">One Time Task</b>
								<div style="margin-top: 10px; margin-left: 35px">
									Launch a quick task
								</div>
							</el-radio>
						</el-col>
						<el-col :span="5">
							<el-radio v-model="radio" label="2"
								><b style="margin-left: 10px">Add to a Project</b>
								<div style="margin-top: 10px; margin-left: 35px">
									Add Form to existing Project
								</div>
							</el-radio>
						</el-col>
						<el-col :span="5">
							<el-radio v-model="radio" label="3"
								><b style="margin-left: 10px">Launch Later</b>
								<div style="margin-top: 10px; margin-left: 35px">
									Save this Form as Draft
								</div>
							</el-radio>
						</el-col>
					</el-row>
				</el-card>
			</el-col>
		</el-row>
		<el-row style="margin-top: 20px">
			<el-col :span="24">
				<el-card style="padding-left: 50px; border-bottom: none" shadow="never">
					<div
						style="
							min-height: 55vh;
							max-height: 55vh;
							overflow-y: auto;
							overflow-x: hidden;
						"
						v-if="radio == '1'"
					>
						<el-row :gutter="5">
							<el-col :span="20" :offset="1">
								<h2>New Task</h2>
							</el-col>
						</el-row>
						<el-row style="margin-top: 30px" :gutter="5">
							<el-col :span="3" :offset="1"> Category </el-col>
							<el-col :span="18" :offset="1"> {{ category }} </el-col>
						</el-row>
						<el-row style="margin-top: 30px" :gutter="5">
							<el-col :span="3" :offset="1"> Form </el-col>
							<el-col :span="18" :offset="1"> {{ title }} </el-col>
						</el-row>
						<el-row style="margin-top: 30px" :gutter="5">
							<el-col :span="3" :offset="1"> Locations </el-col>
							<el-col :span="9" style="margin-top: -10px" :offset="1">
								<el-select
									class="select"
									v-model="locations"
									filterable
									placeholder="Select Locations"
									:multiple="true"
									v-validate="'required'"
									name="Select Locations"
								>
									<el-option
										v-for="(item, key) in locationItems"
										:key="key"
										:label="item.name"
										:value="item.id"
									>
									</el-option>
								</el-select>
								<p>
									<span
										:v-show="errors.has(`Select Locations`)"
										class="text-red-dark text-xs"
									>
										{{ errors.first(`Select Locations`) }}
									</span>
								</p>
							</el-col>
						</el-row>
						<el-row style="margin-top: 30px" :gutter="5">
							<el-col :span="3" :offset="1"> Role / Designation </el-col>
							<el-col :span="9" style="margin-top: -10px" :offset="1">
								<el-select
									class="select"
									v-model="desig_user"
									filterable
									placeholder="Select Role / Designation"
									:multiple="true"
									v-validate="'required'"
									name="Select Role / Designation"
								>
									<el-option
										v-for="(item, key) in desig_userItems"
										:key="key"
										:label="item.name"
										:value="item.id"
									>
									</el-option>
								</el-select>
								<p>
									<span
										:v-show="errors.has(`Select Role / Designation`)"
										class="text-red-dark text-xs"
									>
										{{ errors.first(`Select Role / Designation`) }}
									</span>
								</p>
							</el-col>
						</el-row>
						<el-row style="margin-top: 30px" :gutter="5">
							<el-col :span="3" :offset="1"> Dates </el-col>
							<el-col :span="4" :offset="1" style="margin-top: -10px">
								<el-date-picker
									v-model="startDate"
									type="date"
									placeholder="Select Start Date"
									class="date"
									format="yyyy-MM-dd"
									v-validate="'required'"
									name="Select Start Date"
									:picker-options="datePickerOptions"
								>
								</el-date-picker>
								<p>
									<span
										:v-show="errors.has(`Select Start Date`)"
										class="text-red-dark text-xs"
									>
										{{ errors.first(`Select Start Date`) }}
									</span>
								</p>
							</el-col>
							<el-col :span="4" :offset="1" style="margin-top: -10px">
								<el-date-picker
									style="margin-left: -15px"
									v-model="endDate"
									type="date"
									placeholder="Select End Date"
									class="date"
									format="yyyy-MM-dd"
									v-validate="'required'"
									name="Select End Date"
									:picker-options="fromDatePickerOptions"
								>
								</el-date-picker>
								<p>
									<span
										:v-show="errors.has(`Select End Date`)"
										class="text-red-dark text-xs"
									>
										{{ errors.first(`Select End Date`) }}
									</span>
								</p>
							</el-col>
						</el-row>
					</div>
					<div
						style="
							min-height: 55vh;
							max-height: 55vh;
							overflow-y: auto;
							overflow-x: hidden;
						"
						v-if="radio == '2'"
					>
						<el-row :gutter="5">
							<el-col :span="20" :offset="1">
								<h2>Add to a Project</h2>
							</el-col>
						</el-row>
						<el-row style="margin-top: 30px" :gutter="5">
							<el-col :span="3" :offset="1"> Category </el-col>
							<el-col :span="18" :offset="1"> {{ category }} </el-col>
						</el-row>
						<el-row style="margin-top: 30px" :gutter="5">
							<el-col :span="3" :offset="1"> Form </el-col>
							<el-col :span="18" :offset="1">
								{{ title }}
							</el-col>
						</el-row>

						<el-row style="margin-top: 30px" :gutter="5">
							<el-col :span="3" :offset="1"> Project </el-col>
							<el-col :span="6" style="margin-top: -10px" :offset="1">
								<el-select
									class="select"
									v-model="project"
									filterable
									placeholder="Select Project"
									v-validate="'required'"
									name="Select Project"
								>
									<el-option
										v-for="(item, idx) in projectItems"
										:key="idx"
										:label="item.name"
										:value="item.execution_setup"
									>
									</el-option>
								</el-select>
								<p>
									<span
										:v-show="errors.has(`Select Project`)"
										class="text-red-dark text-xs"
									>
										{{ errors.first(`Select Project`) }}
									</span>
								</p>
							</el-col>
							<el-col :span="1" :offset="1">
								<div style="font-weight: 600">OR</div>
							</el-col>
							<el-col style="margin-top: -10px; margin-left: 30px" :span="3">
								<el-button
									class="button-class-white2"
									icon="el-icon-plus"
									@click="create_new_project()"
								>
									Create New Project
								</el-button>
							</el-col>
						</el-row>
					</div>
					<div
						style="
							min-height: 55vh;
							max-height: 55vh;
							overflow-y: auto;
							overflow-x: hidden;
						"
						v-if="radio == '3'"
					></div>
				</el-card>
				<el-card shadow="none" style="border-top: none">
					<el-row v-if="radio != '0'">
						<el-col style="margin-top: 10px" :span="3" :offset="17">
							<el-button
								class="button-class-white-dialog"
								style="width: 100px"
								@click="prevStep()"
							>
								Back
							</el-button>
						</el-col>
						<el-col style="margin-top: -40px" :span="3">
							<el-button
								@click="nextStep()"
								class="button-class"
								style="width: 150px"
							>
								Continue
							</el-button>
						</el-col>
					</el-row>
				</el-card>

				<el-card
					v-if="radio == '0'"
					style="height: 60vh; border-top: none"
					shadow="never"
				>
					<el-row style="bottom: 0; margin-top: 340px">
						<el-col style="margin-top: 10px" :span="3" :offset="17">
							<el-button
								class="button-class-white-dialog"
								style="width: 100px"
								@click="prevStep()"
							>
								Back
							</el-button>
						</el-col>
					</el-row>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import formBuilderServices from "../../../services/formBuilderServices";
var moment = require("moment");

export default {
	props: {
		category: String,
		title: String,
		formDetails: Object,
		show_add_to_project: Boolean,
	},
	components: {},
	data: () => ({
		datePickerOptions: {
			disabledDate(date) {
				return date < moment().subtract(1, "days");
			},
		},
		radio: "0",
		locations: [],
		locationItems: [],
		desig_user: [],
		desig_userItems: [],
		startDate: "",
		endDate: "",
		project: "",
		projectItems: [],
		formItems: [],
		category_items: [],
		allForms: [],
	}),
	computed: {
		fromDatePickerOptions() {
			return {
				firstDayOfWeek: 1,
				disabledDate: this.disableFromDatePickerDates,
			};
		},
	},
	mounted() {
		this.list_all_categories();
		this.list_designations();
		this.list_locations();
		// this.list_projects();
		if (this.show_add_to_project) {
			this.radio = "2";
		}
	},
	methods: {
		disableFromDatePickerDates(date) {
			if (!this.startDate) {
				return false;
			}
			return date <= this.startDate;
		},
		prevStep() {
			this.$emit("close");
		},
		async list_all_categories() {
			formBuilderServices.listAllCategory().then((res) => {
				this.category_items = JSON.parse(res.data);
				let id = "";
				console.log(this.category_items, "category_items");
				for (let i = 0; i < this.category_items.length; i++) {
					if (this.category_items[i].name == this.category) {
						id = this.category_items[i];
					}
				}
				console.log(id, "id");
				setTimeout(() => {
					this.list_projects(id.id);
				}, 300);
			});
		},
		list_projects(id) {
			formBuilderServices.listAllProjects(id).then((res) => {
				this.projectItems = JSON.parse(res.data);
				console.log("	this.projectItems", this.projectItems);
				this.projectItems.forEach((el) => {
					el.name = el.execution_setup_info.project_info.name;
					el.project_id = el.execution_setup_info.project_info.id;
				});

				console.log(this.projectItems, "Projec");
			});
		},
		list_locations() {
			formBuilderServices.listAllLocations().then((res) => {
				console.log(JSON.parse(res.data), "loc");
				this.locationItems = JSON.parse(res.data);
			});
		},
		list_designations() {
			formBuilderServices.listAllDesignations().then((res) => {
				console.log(JSON.parse(res.data), "designat");
				this.desig_userItems = JSON.parse(res.data);
			});
		},
		create_new_project() {
			this.$emit("create_project");
		},
		nextStep() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (this.radio == "1") {
						let id = "";
						console.log(this.category_items, "category_items");
						for (let i = 0; i < this.category_items.length; i++) {
							if (this.category_items[i].name == this.category) {
								id = this.category_items[i].id;
							}
						}
						let params = {
							project: null,
							execution_setup: {
								id: null,
								execution_type: "standalone",
								assign_to: "designation",
								assign_by: "location",
								designations: this.desig_user,
								locations: this.locations,
								validity_start_date: moment(this.startDate).format(
									"YYYY-MM-DD"
								),
								validity_end_date: moment(this.endDate).format("YYYY-MM-DD"),
								validity_never_ends: false,
								frequency: "monthly",
								daily_schedule_plan: "specific_time",
								weekly_schedule_plan: "specific_day_in_a_week",
								monthly_schedule_plan: "date_of_the_month",
								months_list: ["jan", "feb"],
								date_range_start: 1,
								date_range_end: 1,
								are_grades_applicable: false,
								notification_designations: [],
								report_designations: [],
								notification_on_project_start: true,
								notification_on_project_completed: true,
								notification_on_project_overdue: true,
								reminder_before_project_starts: "00:00:00",
								reminder_before_project_ends: "00:00:00",
							},
							execution_category_mappings: [
								{
									id: null,
									form_category: id,
									forms: new Array(this.formDetails.id),
									is_critical: false,
									allowed_on: "all",
								},
							],
							daily_schedule_times: [],
							week_schedule_days: [],
							month_schedule_dates: [],
							grades: [],
						};
						formBuilderServices
							.addProject(params)
							.then((res) => {
								this.$notify.success({
									title: "Success",
									message: "Form Created Successfully",
									type: "Success",
								});
								console.log(res, "res");
								// window.location.reload();
								this.$emit("get_forms");
								this.isloading = false;
							})
							.catch(() => {
								this.isloading = false;
							});
					}
					if (this.radio == "2") {
						let id = "";
						console.log(this.category_items, "category_items");
						for (let i = 0; i < this.category_items.length; i++) {
							if (this.category_items[i].name == this.category) {
								id = this.category_items[i];
							}
						}
						let patchId = "";
						let formList = [];

						for (let i = 0; i < this.projectItems.length; i++) {
							if (this.projectItems[i].execution_setup == this.project) {
								patchId = this.projectItems[i].id;
							}
							if (this.projectItems[i].execution_setup == this.project) {
								for (let j = 0; j < this.projectItems[i].forms.length; j++) {
									formList.push(this.projectItems[i].forms[j]);
								}
							}
						}
						formList.push(this.formDetails.id);
						let params = {
							execution_setup: this.project,
							form_category: id.id,
							forms: formList,
							is_critical: true,
							allowed_on: "all",
						};
						formBuilderServices
							.patchExecutionCategoryMapping(patchId, params)
							.then((res) => {
								console.log(res, "res patchExecutionCategoryMapping");
								this.$notify.success({
									title: "Success",
									message: "Form Added to Project Successfully",
									type: "Success",
								});
								this.$emit("get_forms");
							});
					}
					if (this.radio == "3") {
						this.$notify.success({
							title: "Success",
							message: "Form Created Successfully!",
							type: "Success",
						});
						this.$emit("get_forms");
					}
				} else {
					alert("Enter required fields");
				}
			});
		},
		create_execution_mapping(res) {
			let id = "";
			console.log(this.category_items, "category_items");
			for (let i = 0; i < this.category_items.length; i++) {
				if (this.category_items[i].name == this.category) {
					id = this.category_items[i];
				}
			}
			console.log(id, "id");
			let params1 = {
				execution_setup: res.id,
				form_category: id.id,
				forms: new Array(this.formDetails.id),
				is_critical: false,
				allowed_on: "all",
			};
			formBuilderServices.createExecutionMapping(params1).then((data) => {
				console.log(data, "data");
				this.$notify.success({
					title: "Success",
					message: "Task created Successfully",
					type: "Success",
				});
				window.location.reload();
			});
		},
	},
};
</script>

<style>
.date .el-input__inner {
	border-radius: 12px;
}
</style>
